export default __webpack_public_path__ + "static/media/select.48178cbc.less";